export const ACTION_GET_SURVEYS = "ACTION_GET_SURVEYS";
export const ACTION_GET_SURVEY_BY_ID = "ACTION_GET_SURVEY_BY_ID";
export const ACTION_GET_QUESTION_TYPES = "ACTION_GET_QUESTION_TYPES";
export const ACTION_GET_CONFIG = "ACTION_GET_CONFIG";
export const ACTION_PUT_CONFIG = "ACTION_PUT_CONFIG";
export const ACTION_POST_CREATE_SURVEY = "ACTION_POST_CREATE_SURVEY";
export const ACTION_PUT_UPDATE_SURVEY = "ACTION_PUT_UPDATE_SURVEY";
export const ACTION_PATCH_SURVEY_STATUS = "ACTION_PATCH_SURVEY_STATUS";
export const ACTION_DELETE_SURVEY = "ACTION_DELETE_SURVEY";
export const ACTION_POST_CREATE_QUESTION = "ACTION_POST_CREATE_QUESTION";
export const ACTION_PUT_UPDATE_QUESTION = "ACTION_PUT_UPDATE_QUESTION";
export const ACTION_DELETE_QUESTION = "ACTION_DELETE_QUESTION";
export const ACTION_REORDER_QUESTIONS = "ACTION_REORDER_QUESTIONS";
export const ACTION_POST_CREATE_OPTION = "ACTION_POST_CREATE_OPTION";
export const ACTION_PUT_UPDATE_OPTION = "ACTION_PUT_UPDATE_OPTION";
export const ACTION_DELETE_OPTION = "ACTION_DELETE_OPTION";
export const ACTION_REORDER_OPTIONS = "ACTION_REORDER_OPTIONS";
export const ACTION_GET_RESPONSES = "ACTION_GET_RESPONSES";
export const ACTION_GET_SUMMARY = "ACTION_GET_SUMMARY";
export const ACTION_GET_OVERVIEW = "ACTION_GET_OVERVIEW";
export const ACTION_PUT_BOT_CONFIG = "ACTION_PUT_BOT_CONFIG";
export const ACTION_DELETE_BOT_CONFIG = "ACTION_DELETE_BOT_CONFIG";
